import * as React from "react";
import { Form } from "antd";
import SelectInput from "../app/SelectInput";
import { ILanguage } from "../../../model/language/Language";

export interface State {}

export interface Props {
  languages: ILanguage[];
  translate: any;
  currentLanguageCode: number;
  changeLanguage(languageCode: number): void;
}

export default class ChangeLanguageForm extends React.Component<Props, State> {
  render() {
    const {
      languages,
      translate,
      currentLanguageCode,
      changeLanguage,
    } = this.props;

    return (
      <div
        style={{
          width: "40%",
          height: 100,
          display: "flex",
          background: "#f0f2f5",
          justifyContent: "space-between",
          flexDirection: "column",
          padding: 10,
          marginBottom: 10,
        }}
      >
        <Form>
          <Form.Item label={translate("change_language_form.language")}>
            <SelectInput
              selectOptions={languages}
              selectOptionKey={"code"}
              selectOptionValue={"name"}
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              style={{ width: "100%" }}
              placeholder={translate(
                "change_language_form.langauge_select_placeholder"
              )}
              value={currentLanguageCode.toString()}
              onSelect={(value, option) => {
                changeLanguage(Number.parseInt(value, 10));
              }}
            />
          </Form.Item>
        </Form>
      </div>
    );
  }
}
